import React, { useState, useContext, useLayoutEffect } from 'react';
import { ApiContext } from '../../contexts/ApiContext';
import CategoryService from '../../service/category.service';
import { useNotification } from '../../contexts/NotificationContext';
import ConfirmDeleteModal from '../../components/ConfirmDeleteModal/ConfirmDeleteModal';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
} from 'reactstrap';

const CategoryForm = ({ category, onClose, accountId, show, setShow }) => {
  const { account } = useContext(ApiContext);
  const resolvedAccountId = accountId || (account && account.id);
  const { notify } = useNotification();

  const [name, setName] = useState('');
  const [active, setActive] = useState(true);
  const [saving, setSaving] = useState(false);
  const [confirmClose, setConfirmClose] = useState(false);

  useLayoutEffect(() => {
    if (!show) return;
    setName(category?.name || '');
    setActive(category?.active ?? true);
    setConfirmClose(false);
  }, [category, show]);

  const isEdit = !!category;
  const isDirty = name !== (category?.name || '') || active !== (category?.active ?? true);

  const handleSubmit = async (e) => {
    e && e.preventDefault();
    setSaving(true);
    try {
      if (isEdit) {
        await CategoryService.update(category.id, { name, active });
      } else {
        await CategoryService.create({ name, accountId: resolvedAccountId, active });
      }
    } catch (err) {
      console.error(err);
      return notify('tr', 'danger', 'Erro ao salvar categoria', 'icon-alert-circle-exc');
    } finally {
      setSaving(false);
    }
    if (setShow) setShow(false);
    if (onClose) onClose();
  };

  const handleClose = () => {
    if (setShow) setShow(false);
    if (onClose) onClose();
  };

  const requestClose = () => {
    if (saving) return;
    if (isDirty) return setConfirmClose(true);
    handleClose();
  };

  return (
    <>
      <Modal isOpen={!!show} toggle={requestClose}>
        <ModalHeader toggle={requestClose}>{isEdit ? 'Editar Categoria' : 'Nova Categoria'}</ModalHeader>
        <Form onSubmit={handleSubmit}>
          <ModalBody>
            <FormGroup>
              <Label for="categoryName">Nome</Label>
              <Input id="categoryName" value={name} onChange={(e) => setName(e.target.value)} required autoFocus />
            </FormGroup>
            <FormGroup check>
              <Label check>
                <Input type="checkbox" checked={active} onChange={(e) => setActive(e.target.checked)} />
                <span className="form-check-sign">
                  <span className="check" />
                </span>
                {' '}Ativa
              </Label>
            </FormGroup>
          </ModalBody>
          <ModalFooter className="pt-3">
            <div className="w-100 d-flex justify-content-end">
              <Button color="secondary" onClick={handleClose} className="mr-2">
                Cancelar
              </Button>
              <Button color="primary" type="submit" disabled={saving}>
                {saving ? 'Salvando...' : 'Salvar'}
              </Button>
            </div>
          </ModalFooter>
        </Form>
      </Modal>
      <ConfirmDeleteModal
        isOpen={confirmClose}
        toggle={() => setConfirmClose(false)}
        title="Descartar alterações?"
        message="Você tem alterações não salvas nesta categoria. Se fechar agora, elas serão perdidas."
        btnConfirm="Descartar"
        btnCancel="Continuar editando"
        onConfirm={handleClose}
      />
    </>
  );
};

export default CategoryForm;
